module.exports = __webpack_public_path__ + "files/e4efe4ba0c9b46d934c4c853b6a839d7.png";